module.exports = __webpack_public_path__ + "img/google-ar-3x.6ff875cc.png";